import { render, staticRenderFns } from "./tab-pane.vue?vue&type=template&id=77b4cf3a"
import script from "./tab-pane.vue?vue&type=script&setup=true&lang=js"
export * from "./tab-pane.vue?vue&type=script&setup=true&lang=js"
import style0 from "./tab-pane.vue?vue&type=style&index=0&id=77b4cf3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports